import { computed as c, createElementBlock as t, openBlock as s, createVNode as m, createCommentVNode as o, normalizeClass as l, toDisplayString as i } from "vue";
import r from "../../atoms/image-element/image-element.vue.js";
const p = {
  key: 0,
  class: "ds-flex-grow-1 ds-text ds-font-weight-bold ds-margin-right-12"
}, g = {
  key: 1,
  class: "ds-flex-grow-1 ds-text ds-text-align-right"
}, f = /* @__PURE__ */ Object.assign({
  name: "DsImageWithFooter"
}, {
  __name: "image-with-footer",
  props: {
    ...r.props,
    // Used for full screen images
    isFooterNarrow: {
      type: Boolean,
      default: !1
    }
  },
  setup(a) {
    const n = a, d = c(() => {
      const e = n.image;
      return (e == null ? void 0 : e.caption) || (e == null ? void 0 : e.source);
    });
    return (e, h) => (s(), t("div", null, [
      m(r, {
        image: e.image,
        "aspect-ratio": e.aspectRatio,
        "with-shadow": e.withShadow,
        "with-padding": e.withPadding,
        screen: e.screen
      }, null, 8, ["image", "aspect-ratio", "with-shadow", "with-padding", "screen"]),
      d.value ? (s(), t("div", {
        key: 0,
        class: l(["ds-display-flex ds-justify-content-space-between ds-align-items-center ds-margin-top-24", { "ds-margin-x-24 ds-md-margin-x-48": a.isFooterNarrow }])
      }, [
        e.image.caption ? (s(), t("p", p, i(e.image.caption), 1)) : o("", !0),
        e.image.source ? (s(), t("p", g, i(e.image.source), 1)) : o("", !0)
      ], 2)) : o("", !0)
    ]));
  }
});
export {
  f as default
};
